import { useRef } from "react";
import { hrefReturningHere } from "../lib/auth-redirect";

const SIGN_IN_PATH = "/sign-in";

/**
 * Returns a stable callback that redirects the user to /sign-in,
 * preserving the current URL in `redirect_url`. Idempotent: only
 * the first invocation per hook instance triggers the navigation.
 */
export function useAuthRedirect(): () => void {
  const hasRedirectedRef = useRef(false);
  return () => {
    if (hasRedirectedRef.current) return;
    hasRedirectedRef.current = true;
    if (!window.location.pathname.startsWith(SIGN_IN_PATH)) {
      window.location.href = hrefReturningHere(SIGN_IN_PATH);
    }
  };
}
